<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceTech()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Service Technician Home</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-11">
	<br>
<h5><b>Job Status Updates</b></h5>
<br>
<div class="card card-danger card-outline">
		<div class="card-body overflow-auto">
      <!-- <img v-if="lots==''" src="../images/nodata.svg">	 -->
			<h5 v-if="messages == ''"><p>No job status updates pending.</p></h5>
			<!-- content here -->
      <div v-else v-for="m in messages" :key="m.id">
        <div v-if="m.tat_flag==0">
          <div class="alert alert-warning alert-dismissible fade show" role="alert">
            <a class="button btn btn-primary" :href="'/service-tech/job-profile/'+m.job_id" style="color: white; text-decoration: none;"><i class='fa fa-pencil'></i> Update</a>
            &nbsp;<strong>{{m.message}}</strong>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="markRead(m.id)">
    		  	<span aria-hidden="true">&times;</span>
  			    </button>
        </div>
        </div>

        <div v-if="m.tat_flag==1">
          <div class="alert alert-danger alert-dismissible fade show" role="alert">
            <a class="button btn btn-danger" :href="'/service-tech/job-profile/'+m.job_id" style="color: white; text-decoration: none;"><i class='fa fa-pencil'></i> Update</a>
            &nbsp;<strong>{{m.message}}</strong>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="markRead(m.id)">
    		  	<span aria-hidden="true">&times;</span>
  			    </button>
        </div>
        </div>

      </div>

			
    </div>
	</div>
</div>
<br>


<div class="col-md-11">
  <br>
<h5><b>Job Statistics</b></h5>
<br>
<h4>Today</h4>
<br>
<div class="row" align="center">

 <div class="col-lg-4 col-6">
            <!-- small box -->
            <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{today}}</h3>

                <p>New</p>
              </div>
              <div class="icon">
                <i class="ion ion-person-add"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
          </div>

          <div class="col-lg-4 col-6">
            <!-- small box -->
            <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{pending}}</h3>
                <p>Pending</p>
              </div>
              <div class="icon">
                <i class="ion ion-pie-graph"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
          </div>

          <div class="col-lg-4 col-6">
            <!-- small box -->
            <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{completed}}</h3>
                <p>Completed</p>
              </div>
              <div class="icon">
                <i class="ion ion-bag"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
          </div>

          </div>
          <br>
          <h4>This Month</h4>
          <br>

        <div class="row">
          <div class="col-lg-6 col-6">
            <!-- small box -->
            <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{monthnew}}</h3>
                <p>New</p>
              </div>
              <div class="icon">
                <i class="ion ion-person-add"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
          </div>

          <div class="col-lg-6 col-6">
            <!-- small box -->
            <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{monthcompleted}}</h3>
                <p>Completed</p>
              </div>
              <div class="icon">
                <i class="ion ion-bag"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
          </div>



<!-- content here -->

</div>

</div>

<!-- row end -->
    </section>
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceTech()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getNotifs();
        	this.getCount();
        },
        
        data(){
        	return {
        		messages: [],
        		today: '-',
        		pending: '-',
        		completed: '-',
        		monthnew: '-',
        		monthcompleted: '-',
        		categories: []
        	}
        },
        
        methods: {
        	getNotifs(){
        		axios.post("/api/getNotifs")
        		.then(response => {
        			this.messages = response.data;
        		})
        	},
        	
        	markRead(id){
        		axios.post("/api/markRead", {id: id})
        		.then(() => {
        			this.getNotifs();
        		})
        	},
        	
        	getCount(){
        		axios.post("/api/getTechCount")
        		.then(response => {
        			this.today = response.data.today;
        			this.completed = response.data.completed;
        			this.pending = response.data.pending;
        			this.monthnew = response.data.monthnew;
        			this.monthcompleted = response.data.monthcompleted;
        			this.categories = response.data.categories;
        		})
        	}
        }
    }
</script>
